import { useLazyQuery } from '@apollo/client';
import { graphql } from '../gql';

export const GET_SUBMISSION_COUNT = graphql(`
  query getSubmissionCount(
    $isSubmissionQueue: Boolean!
    $isUnderwriteQueue: Boolean!
  ) {
    inProgress: submissions(filters: { status: SUBMITTED })
      @include(if: $isSubmissionQueue) {
      pageInfo {
        totalResults
      }
    }
    completed: submissions(filters: { status: CLEARED })
      @include(if: $isUnderwriteQueue) {
      pageInfo {
        totalResults
      }
    }
    cleared: submissions(filters: { status: CLEARED })
      @include(if: $isSubmissionQueue) {
      pageInfo {
        totalResults
      }
    }
    declined: submissions(filters: { status: DECLINED })
      @include(if: $isSubmissionQueue) {
      pageInfo {
        totalResults
      }
    }
    beingEvaluated: submissions(filters: { status: EVALUATION })
      @include(if: $isUnderwriteQueue) {
      pageInfo {
        totalResults
      }
    }
    indicated: submissions(filters: { status: EVALUATION })
      @include(if: $isUnderwriteQueue) {
      pageInfo {
        totalResults
      }
    }
    quoted: submissions(filters: { status: QUOTED })
      @include(if: $isUnderwriteQueue) {
      pageInfo {
        totalResults
      }
    }
    bound: submissions(filters: { status: BOUND })
      @include(if: $isUnderwriteQueue) {
      pageInfo {
        totalResults
      }
    }
    rejected: submissions(filters: { status: DECLINED })
      @include(if: $isUnderwriteQueue) {
      pageInfo {
        totalResults
      }
    }
  }
`);

export interface IUseGetSubmissionCountArgQuery {
  status: string[];
}

export function useGetSubmissionCountQuery(
  isSubmissionQueue: boolean,
  isUnderwriteQueue: boolean
) {
  const [load, { loading, data, error }] = useLazyQuery(GET_SUBMISSION_COUNT, {
    variables: {
      isSubmissionQueue,
      isUnderwriteQueue,
    },
    fetchPolicy: 'cache-and-network',
  });
  return {
    load,
    error,
    loading,
    data,
  };
}
